// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CategoriesPage_tableWrapper__KdJtB","oddRow":"CategoriesPage_oddRow__NzZ9T"};